import { Button } from './button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './dialog';

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  titulo: string;
  descripcion: string;
  confirmar: string;
  confirmando?: string;
  cancelar: string;
  onConfirmar: () => void;
  pendiente?: boolean;
  variant?: 'default' | 'danger';
}

// Confirmación nativa de la app (nunca window.confirm) — mismo look que el
// resto de los diálogos (Dialog/DialogContent de Radix).
export function ConfirmDialog({
  open,
  onOpenChange,
  titulo,
  descripcion,
  confirmar,
  confirmando,
  cancelar,
  onConfirmar,
  pendiente = false,
  variant = 'default',
}: ConfirmDialogProps): JSX.Element {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
          <DialogDescription>{descripcion}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            {cancelar}
          </Button>
          <Button
            type="button"
            variant={variant === 'danger' ? 'danger' : 'default'}
            onClick={onConfirmar}
            disabled={pendiente}
          >
            {pendiente ? (confirmando ?? confirmar) : confirmar}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
